export default "__VITE_ASSET__ab40b8eb__"